import React,{useState,useRef,useEffect} from 'react'
// import { useSelector } from 'react-redux';
import PlayerControl from './PlayerControl'
import PlayerDetails from './PlayerDetails'

function Player(props) {
  const audioEl = useRef(null);
  const [isPlaying,setPlaying] = useState(false);
  const [isMute,setMute] = useState(false);
  const [time,setTime] = useState(0);
  const  [duration,setDuration] = useState(0);
  // const {play} = useSelector((state)=>state.playing)

  useEffect(()=>{
        if(isPlaying){
          audioEl.current.play();
          const run = ()=>{
            setDuration(Math.floor(audioEl.current.duration))
          }
          run()
          setInterval(()=>{
            let timestamp = Math.floor(audioEl.current.currentTime);
            setTime(timestamp);
            if(audioEl.current.ended){
              setPlaying(false)
              clearInterval()
            }
          },1100)
        }else{
          audioEl.current.pause();
        }
    if(isMute){
      audioEl.current.volume = 0;
    }else{
      audioEl.current.volume = 1;
    }
  })

  const skipSong = (forward = true)=>{
    if(forward){
      props.setCurrentSongIndex(()=>{
        let temp = props.currentSongIndex;
        temp++;

        if(temp > props.songs.length-1){
          temp = 0;
        }

        return temp;
      })
    }else{
      props.setCurrentSongIndex(()=>{
        let temp = props.currentSongIndex;
        temp--;

        if(temp < 0){
          temp = props.songs.length-1;
        }

        return temp;
      })
    }
  }

  return (
    <>
      <audio id='audio' ref={audioEl} src={props.songs[props.currentSongIndex].src}></audio>
      <nav className="player">
        <PlayerDetails song={props.songs[props.currentSongIndex]}/>
        <PlayerControl 
          isPlaying={isPlaying} 
          setPlaying={setPlaying} 
          skipSong={skipSong}
          isMute={isMute}
          setMute={setMute}
          time={time}
          duration = {duration}
          audioEl ={audioEl}
        />
      </nav>
    </>
  )
}

export default Player